exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".screen_link{\n    cursor:pointer\n}", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// /Users/andrescufari/Angular/billbo-desktop-v2/src/app/components/index/index.component.css
// module id = ../../../../../src/app/components/index/index.component.css
// module chunks = main